import uppyLocaleEn from '@uppy/locales/lib/en_US.js';

export default {
  Language: 'Language',
  Dossier: 'Dossier',
  Create: 'Create',
  Close: 'Close',
  Cancel: 'Cancel',
  Save: 'Save',
  Edit: 'Edit',
  Crop: 'Crop',
  'New Folder': 'New Folder',
  'New File': 'New File',
  Rename: 'Rename',
  Delete: 'Delete',
  Upload: 'Upload',
  Download: 'Download',
  Move: 'Move',
  Archive: 'Archive',
  Unarchive: 'Unarchive',
  Open: 'Open',
  'Open containing folder': 'Open containing folder',
  Refresh: 'Refresh',
  Preview: 'Preview',
  'Toggle Full Screen': 'Toggle Full Screen',
  'Change View': 'Change View',
  Storage: 'Storage',
  'Go up a directory': 'Go up a directory',
  Go: 'Go',
  'Enter folder path:': 'Enter folder path:',
  'Invalid path format. Path must be in format: storage://path/to/folder':
    'Invalid path format. Path must be in format: storage://path/to/folder',
  'Invalid storage. Storage "%s" is not available.':
    'Invalid storage. Storage "%s" is not available.',
  'Failed to navigate to folder': 'Failed to navigate to folder',
  'Copy Path': 'Copy Path',
  'Copy path': 'Copy path',
  'Path copied to clipboard': 'Path copied to clipboard',
  'Toggle Path Copy Mode': 'Toggle Path Copy Mode',
  'Copy Download URL': 'Copy Download URL',
  'Search anything..': 'Search anything..',
  Name: 'Name',
  'Date modified': 'Date modified',
  'Date uploaded': 'Date uploaded',
  Type: 'Type',
  Size: 'Size',
  Date: 'Date',
  Filepath: 'Filepath',
  'Folder Name': 'Folder Name',
  'File Name': 'File Name',
  'Move files': 'Move files',
  'Yes, Move!': 'Yes, Move!',
  'Delete files': 'Delete files',
  Password: 'Password',
  'The file is password-protected from editing. Enter the password to delete it.': 'The file is password-protected from editing. Enter the password to delete it.',
  'Yes, Delete!': 'Yes, Delete!',
  'Upload Files': 'Upload Files',
  'No files selected!': 'No files selected!',
  'Select Files': 'Select Files',
  'Archive the files': 'Archive the files',
  'Unarchive the files': 'Unarchive the files',
  'The archive will be unarchived at': 'The archive will be unarchived at',
  'Archive name. (.zip file will be created)': 'Archive name. (.zip file will be created)',
  'A modern, customizable file manager component built for Vue.':
    'A modern, customizable file manager component built for Vue.',
  'Create a new folder': 'Create a new folder',
  'Create a new file': 'Create a new file',
  'Create folder': 'Create folder',
  'Create Word': 'Create Word',
  'Create Excel': 'Create Excel',
  More: 'More',
  'Folder (create)': 'Folder',
  'Word document (create)': 'Word document',
  'Excel workbook (create)': 'Excel workbook',
  History: 'History',
  'Give access': 'Give access',
  'Access settings': 'Access settings',
  'No access subjects': 'No access subjects',
  'Failed to load access settings': 'Failed to load access settings',
  'Can read': 'Read',
  'Can edit': 'Edit',
  'Upload to folder': 'Upload to folder',
  Path: 'Path',
  Favorites: 'Favorites',
  Trash: 'Trash',
  'My trash': 'My trash',
  'No favorites': 'No favorites',
  'Add to favorites': 'Add to favorites',
  'Remove from favorites': 'Remove from favorites',
  'File folder': 'File folder',
  'Selected items will be downloaded as an archive':
    'Selected items will be downloaded as an archive',
  'Selected file will be downloaded': 'Selected file will be downloaded',
  'Are you sure you want to delete these files?': 'Are you sure you want to delete these files?',
  "I'm sure delete it, This action cannot be undone.":
    'I confirm I want to delete this. This action cannot be undone.',
  'Search results for': 'Search results for',
  '%s item(s) selected.': '%s item(s) selected.',
  '%s is renamed.': '%s is renamed.',
  'File extension cannot be changed.': 'File extension cannot be changed.',
  'This is a readonly storage.': 'This is a readonly storage.',
  '%s is created.': '%s is created.',
  'Files moved.': 'Files moved.',
  'Files deleted.': 'Files deleted.',
  'The file unarchived.': 'The file unarchived.',
  'The file(s) archived.': 'The file(s) archived.',
  'Updated.': 'Updated.',
  'No search result found.': 'No search result found.',
  'Are you sure you want to move these files?': 'Are you sure you want to move these files?',
  'File Size': 'File Size',
  'Last Modified': 'Last Modified',
  'Select Folders': 'Select Folders',
  'Clear all': 'Clear all',
  'Clear only successful': 'Clear only successful',
  'Drag and drop the files/folders to here.': 'Drag and drop the files/folders to here.',
  'You can drag & drop files anywhere while this modal is open.':
    'You can drag & drop files anywhere while this modal is open.',
  Canceled: 'Canceled',
  Done: 'Done',
  'Network Error, Unable establish connection to the server or interrupted.':
    'Network Error, Unable establish connection to the server or interrupted.',
  'Pending upload': 'Pending',
  'Please select file to upload first.': 'Please select file to upload first.',
  Status: 'Status',
  'Conflict: choose an action': 'Conflict: choose an action',
  'Will be uploaded': 'Will be uploaded',
  'A file named "%s" already exists in the destination folder': 'A file named "%s" already exists in the destination folder',
  'The destination folder already contains files with the same names': 'The destination folder already contains files with the same names',
  'Replacing creates a new version of the file.': 'Replacing creates a new version of the file.',
  'Other files will be uploaded.': 'Other files will be uploaded.',
  'Replace the file in the destination folder': 'Replace the file in the destination folder',
  'Replace the files in the destination folder': 'Replace the files in the destination folder',
  'Skip this file': 'Skip this file',
  'Skip these files': 'Skip these files',
  'Cancel upload': 'Cancel upload',
  Skipped: 'Skipped',

  Settings: 'Settings',
  Shortcuts: 'Shortcuts',
  Reset: 'Reset',
  Escape: 'Escape',
  Search: 'Search',
  'Toggle Sidebar': 'Toggle Sidebar',
  'Open Settings': 'Open Settings',
  'Reset all settings to default': 'Reset all settings to default',
  'Saved.': 'Saved.',
  'Reset Settings': 'Reset Settings',
  'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".':
    'Download doesn\'t work? You can try right-click "Download" button, select "Save link as...".',
  Theme: 'Theme',
  'Target Directory': 'Target Directory',
  Select: 'Select',
  'Select this folder': 'Select this folder',
  Selected: 'Selected',
  'Ctrl/Cmd + click to select multiple files': 'Ctrl/Cmd + click to select multiple files',
  'Ctrl/Cmd + click to add files; Shift + click to select a range': 'Ctrl/Cmd + click to add files; Shift + click to select a range',
  'This folder is empty.': 'This folder is empty.',
  'Show thumbnails': 'Show thumbnails',
  'Persist Path': 'Persist Path',
  'Metric Units': 'Metric Units',
  'Select All': 'Select All',
  'Pinned Folders': 'Pinned Folders',
  'No folders pinned': 'No folders pinned',
  'No folders': 'No folders',
  'Pin Folder': 'Pin Folder',
  'Unpin Folder': 'Unpin Folder',

  'Project Home': 'Project Home',
  'If you like it, please follow and ⭐ star on GitHub.':
    'If you like it, please follow and ⭐ star on GitHub.',
  'Customize your experience with the following settings':
    'Customize your experience with the following settings',
  File: 'File',
  View: 'View',
  Tools: 'Tools',
  Help: 'Help',
  Exit: 'Exit',
  'Deselect All': 'Deselect All',
  Cut: 'Cut',
  Copy: 'Copy',
  Paste: 'Paste',
  'Grid View': 'Grid View',
  'List View': 'List View',
  'Tree View': 'Tree View',
  'Show Thumbnails': 'Show Thumbnails',
  'Full Screen': 'Full Screen',
  items: 'items',
  selected: 'selected',
  About: 'About',
  Git: 'Git',
  Forward: 'Forward',
  Back: 'Back',
  'Go to Folder': 'Go to Folder',
  Sorting: 'Sorting',
  Asc: 'Asc',
  Desc: 'Desc',
  None: 'None',
  Show: 'Show',
  'All items': 'All items',
  'Files only': 'Files only',
  'Folders only': 'Folders only',
  'Show hidden files': 'Show hidden files',
  'Copy files': 'Copy files',
  'Are you sure you want to copy these files?': 'Are you sure you want to copy these files?',
  'Yes, Copy!': 'Yes, Copy!',
  'Files copied.': 'Files copied.',
  Browse: 'Browse',
  'Create a copy instead of moving': 'Create a copy instead of moving',
  'Download failed': 'Download failed',
  'Select Target Folder': 'Select Target Folder',
  Storages: 'Storages',
  Loading: 'Loading',
  'Search files': 'Search files',
  'Failed to open containing folder': 'Failed to open containing folder',
  'Include subfolders': 'Include subfolders',
  'More actions': 'More actions',
  'Open Containing Folder': 'Open Containing Folder',
  'Searching...': 'Searching...',
  'No results found': 'No results found',
  'Found %s results': 'Found %s results',
  'Search failed': 'Search failed',
  'Search Options': 'Search Options',
  'All Files': 'All Files',
  'Small (< 1MB)': 'Small (< 1MB)',
  'Medium (1-10MB)': 'Medium (1-10MB)',
  'Large (> 10MB)': 'Large (> 10MB)',
  'Start typing to search files. Use options to filter or include subfolders.':
    'Start typing to search files. Use options to filter or include subfolders.',
  // FinderError.code → toast (docparser)
  'errors.folder_exists': 'Folder "%s" already exists',
  'errors.file_exists': 'File "%s" already exists',
  'errors.destination_exists': 'Destination "%s" already exists',
  'errors.folder_name_reserved': 'Folder name "%s" is reserved',
  'errors.item_not_found': 'Dossier item was not found',
  'errors.root_immutable': 'Root storage cannot be modified',
  'errors.access_denied': 'No access to the selected dossier item',
  'errors.access_acl_denied': 'No access to manage dossier permissions',
  'errors.user_not_found': 'User "%s" was not found',
  'errors.role_not_found': 'Role "%s" was not found',
  'errors.nothing_selected': 'Nothing selected',
  'errors.destination_required': 'Destination folder is required',
  'errors.invalid_self_target': 'A folder cannot be copied or moved into itself',
  'errors.upload_empty': 'No files were uploaded',
  'errors.upload_invalid_names': 'Invalid upload file names',
  'errors.wrong_password': 'Wrong password for file "%s"',
  'errors.archive_not_found': 'Archive was not found',
  'errors.invalid_archive': 'Invalid or unsafe archive',
  'errors.conversion_input': 'Provide at least one file or id',
  'errors.conversion_limit': 'At most %s files are accepted per batch',
  'errors.conversion_expired': 'Conversion result has expired, please re-run conversion',
  'errors.projects_disabled': 'Projects storage is unavailable',
  'errors.projects_read_only': 'Projects storage is read-only',
  'errors.projects_path_invalid': 'Invalid projects path or object id',
  'errors.range_invalid': 'Invalid request range',
  'errors.storage_misconfigured': 'Dossier storage is misconfigured',
  'errors.storage_unavailable': 'Storage is temporarily unavailable',
  'errors.index_stale': 'Projects index is stale',
  'errors.index_unavailable': 'Projects index is unavailable',
  'errors.auth_required': 'Authentication is required',
  'errors.bad_request': 'Invalid request',
  uppy: uppyLocaleEn,
};
